import en from './en';
import ar from './ar';

export const dictionaryList = {
  ar,
  en
};

export const languageOptions = [
  { id: 'ar', text: 'عربي' },
  { id: 'en', text: 'English'}
];